import { CityType, CountryType } from 'modules/types/LocationCodes';

export const mapToCountryOptions = (countries?: CountryType[]) =>
  countries?.map((country) => ({
    label: country.nameCroatian,
    value: country.isoCode,
  }));

export const mapToCityOptions = (cities?: CityType[]) => {
  const mappedCities = cities?.map((city) => ({
    label: `${city.placeName}`,
    value: city.placeName,
  }));

  return mappedCities?.filter(
    (city, index, self) =>
      index === self.findIndex((c) => c.value === city.value),
  );
};

export const mapToCityAndZipCodeOptions = (cities?: CityType[]) =>
  cities?.map((city) => ({
    label: `${city.placeName} (${city.number})`,
    value: city.gemicroPostalCode,
  }));
